export default __webpack_public_path__ + "static/media/flagIcon.2b4f7350.png";